import { Service, signal } from '@angular/core';
import { MarketGroupDto } from '../models/market-groups-api.model';
import { readStoredMarketGroups, writeStoredMarketGroups } from '../models/market-groups.storage';

import { KalaApiResponse } from '../models/kala-api.model';
import { BaseService } from './base.service';

@Service()
export class TradingTimeService extends BaseService {
	private readonly _marketGroups = signal<readonly MarketGroupDto[]>(readStoredMarketGroups());
	readonly marketGroups = this._marketGroups.asReadonly();

	load(): void {
		this.http.get<KalaApiResponse<MarketGroupDto[]>>(`${this.kalaApiPath}/symbols/groups`).subscribe({
			next: response => {
				if (response.data.length > 0) {
					this._marketGroups.set(response.data);
					writeStoredMarketGroups(response.data);
				}
			}
		});
	}
}
